// services/QuestionService.js
import api from "../utils/axios";
import { ENDPOINTS } from "../utils/endpoints";

// LIST (paginated)
export function getQuestions(params = {}) {
    return api.get(ENDPOINTS.QUESTIONS.BASE, { params });
}
export function getQuestionById(id) {
    return api.get(ENDPOINTS.QUESTIONS.BY_ID(id));
}
// CREATE / UPDATE : le tableau `answers` est envoyé directement dans le payload
export function createQuestion(payload) {
    return api.post(ENDPOINTS.QUESTIONS.BASE, payload);
}
export function updateQuestion(id, payload) {
    return api.patch(ENDPOINTS.QUESTIONS.BY_ID(id), payload);
}
export function deleteQuestion(id) {
    return api.delete(ENDPOINTS.QUESTIONS.BY_ID(id));
}
export function restoreQuestion(id) {
    return api.post(`${ENDPOINTS.QUESTIONS.BY_ID(id)}/restore`);
}

// IMAGE D'ILLUSTRATION D'UNE QUESTION : envoi (multipart, champ "image") / retrait
export function uploadQuestionImage(id, file) {
    const formData = new FormData();
    formData.append("image", file);
    return api.post(ENDPOINTS.QUESTIONS.IMAGE(id), formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
}
export function deleteQuestionImage(id) {
    return api.delete(ENDPOINTS.QUESTIONS.IMAGE(id));
}
